import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

const NO_AUTO = { autoCapitalize: "off", autoCorrect: "off", spellCheck: false };

export const Field = ({ label, testId, type, ...props }) => {
  const [show, setShow] = useState(false);
  const isPwd = type === "password";
  return (
    <div className="space-y-1.5">
      {label && <Label className="text-xs text-[var(--rose)]">{label}</Label>}
      <div className="relative">
        <Input data-testid={testId} type={isPwd ? (show ? "text" : "password") : type} className={`h-11 bg-[var(--wine)] border-[var(--line)] focus-visible:ring-[var(--accent-c)] ${isPwd ? "pr-11" : ""}`} {...(isPwd || props.autoComplete === "username" ? NO_AUTO : {})} {...props} />
        {isPwd && (
          <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"} className="absolute right-1 top-1 h-9 w-9 rounded-lg inline-flex items-center justify-center text-[var(--muted-text)] hover:text-[var(--text)] hover:bg-black/5 transition-colors">
            {show ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
    </div>
  );
};

export const ChoiceGroup = ({ options, value, onChange, testId, cols = 3 }) => (
  <div className={`grid grid-cols-${cols} gap-2`} data-testid={testId}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        data-testid={`${testId}-${o.value}`}
        onClick={() => onChange(o.value)}
        className={`rounded-xl h-11 px-2 text-sm font-semibold inline-flex items-center justify-center gap-1.5 transition-colors duration-200 border ${
          value === o.value ? "bg-[var(--accent-c)] border-[var(--accent-c)] text-white shadow-[0_8px_20px_-8px_rgba(30,136,255,0.7)]" : "bg-white border-[var(--line)] text-[var(--muted-text)] hover:border-[rgba(30,136,255,0.5)]"
        }`}
      >
        {o.icon} {o.label}
      </button>
    ))}
  </div>
);
